import React from 'react'
import Image from '../imgix-img'
import getImageHost from '../../utils/get-image-host'

export const LoadingOverlay = () => (
  <div className='LoadingOverlay'>
    <div className='LoadingOverlay-content'>
      <Image
        className='eligibility-progress'
        src={`https://${getImageHost()}/t014ej9w3ur1/1OwC7SSchbBiyNideKf1ld/50f29a2ce692e79c45aa716380757bb0/Loadingstate2.gif?h=544`}
        alt='eligibility-progress-animation'
        originalSize={true}
        critical={false}
      />
    </div>
  </div>
)
